import { render, staticRenderFns } from "./SelectedDataDisplay.vue?vue&type=template&id=6c5f16c7&scoped=true"
import script from "./SelectedDataDisplay.vue?vue&type=script&lang=js"
export * from "./SelectedDataDisplay.vue?vue&type=script&lang=js"
import style0 from "./SelectedDataDisplay.vue?vue&type=style&index=0&id=6c5f16c7&prod&scoped=true&lang=css"
import style1 from "./SelectedDataDisplay.vue?vue&type=style&index=1&id=6c5f16c7&prod&lang=css"
import style2 from "./SelectedDataDisplay.vue?vue&type=style&index=2&id=6c5f16c7&prod&scoped=true&lang=css"
import style3 from "./SelectedDataDisplay.vue?vue&type=style&index=3&id=6c5f16c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f16c7",
  null
  
)

export default component.exports